const REACT_APP_VERSION = process.env.REACT_APP_VERSION;

function Footer() {
  return (
    <>
      {/* <!-- Footer --> */}
      <footer className="bg-white iq-footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6"></div>
            <div className="col-lg-6 text-right">
              &copy;{new Date().getFullYear() + " "}, All Rights Reserved.{" "}
              <a href="#"> Version: {REACT_APP_VERSION} </a>
            </div>
          </div>
        </div>
      </footer>
      {/* <!-- Footer END --> */}
    </>
  );
}

export default Footer;
